import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";
import Section10 from "./Section10";
import Section11 from "./Section11";


export default function Seo() {
  return (
    <div className="Seo pt-[160px] sm:pt-0">
      <Helmet>
        <title>Best SEO Services company | Top SEO Agency | SEO Experts</title>
        <meta
        name="description"
        content="Grow traffic and revenue with Mean3 SEO services. From technical SEO audits to local and ecommerce SEO, our expert agency delivers measurable results."
        />
      </Helmet>
      <Section1 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
      <Section11 />
      <Section9 />
      {/* <Section2 /> */}
      <Section10 />
      <Section3 />

    </div>
  );
}
